import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import TopNavbar from "./ui/countdown/topNavbar/topNavbar";
import MiddleHeader from "./ui/headers/middleHeader";
import Searchbar from "./includes/Searchbar";
import Footer from "./ui/footer/footer";
import Searchfield from "./ui/searchfield/Searchfield";
import { Helmet } from "react-helmet";

function LandingPageDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await axios.get(`/blog/${slug}`);
        setArticle(res.data);
        window.scrollTo(0, 0);
      } catch (err) {
        console.error("Error loading landing page:", err);
      }
    };

    fetchArticle();
  }, [slug]);

  if (!article) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Helmet>
        <title>{article?.title}</title>
        <meta name="description" content={article?.excerpt || article?.title} />
        <meta property="og:title" content={article?.title} />
        <meta
          property="og:description"
          content={article?.excerpt || article?.title}
        />
        <meta property="og:image" content={article?.cover_image} />
        <meta
          property="og:url"
          content={`https://www.bestpreispyro.de/blog/${slug}`}
        />
        <link
          rel="canonical"
          href={`https://www.bestpreispyro.de/blog/${slug}`}
        />
      </Helmet>
      <div className="page-wrapper">
        <header className="header">
          <TopNavbar />
          <MiddleHeader />
          <Searchbar />
          <Searchfield />
        </header>

        <main className="main">
          <div className="page-header">
            <div className="container">
              <h1
                className="page-title mb-0 text-5xl font-bold"
                style={{ marginTop: "2rem", marginBottom: "2rem" }}
              >
                {article.title}
              </h1>
            </div>
          </div>

          <div className="page-content mb-12" style={{ marginTop: "2rem" }}>
            <div className="container pb-10 mb-2">
              <div className="main-content post-single-content">
                <div className="post post-grid post-single">
                  {article.cover_image && (
                    <figure className="post-media br-sm">
                      <img
                        src={article.cover_image}
                        alt={article.title}
                        width="930"
                        height="500"
                        style={{ objectFit: "cover", borderRadius: "8px" }}
                      />
                    </figure>
                  )}
                  <div className="post-details">
                    <div
                      className="prose max-w-full"
                      style={{ fontSize: "14px", color: "#666" }}
                      dangerouslySetInnerHTML={{ __html: article.html }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}

export default LandingPageDetail;
